import { useState, useEffect, useCallback } from "react";
import { getApiBaseUrl } from "../utils/api";

const API_BASE_URL = getApiBaseUrl();

const useUsersData = (user) => {
  // State for users data
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // Pagination state
  const [usersPagination, setUsersPagination] = useState({
    current_page: 1,
    per_page: 25,
    total: 0,
    total_pages: 0,
    has_next: false,
    has_prev: false,
  });

  // Search states
  const [userSearchTerm, setUserSearchTerm] = useState("");
  const [userSearchQuery, setUserSearchQuery] = useState("");

  // Fetch users function
  const fetchUsers = useCallback(
    async (page = 1, search = "") => {
      if (!user?.id) {
        console.error("User ID not available");
        return;
      }

      try {
        setLoading(true);
        const response = await fetch(
          `${API_BASE_URL}/admin/users?user_id=${
            user.id
          }&page=${page}&per_page=25&search=${encodeURIComponent(search)}`
        );
        const data = await response.json();
        setUsers(data.users || []);
        if (data.pagination) {
          setUsersPagination(data.pagination);
        }
      } catch (error) {
        console.error("Error fetching users:", error);
        setError("Erro ao carregar usuários");
      } finally {
        setLoading(false);
      }
    },
    [user?.id]
  );

  // Initialize data on mount
  useEffect(() => {
    if (user?.id) {
      fetchUsers();
    }
  }, [user?.id, fetchUsers]);

  const returnValue = {
    // Data
    users,

    // States
    loading,
    error,
    setError,

    // Pagination
    usersPagination,

    // Search
    userSearchTerm,
    setUserSearchTerm,
    userSearchQuery,
    setUserSearchQuery,

    // Functions
    fetchUsers,
  };

  return returnValue;
};

export default useUsersData;
